module.exports = __webpack_public_path__ + "img/icon_twitter.3e8e7ee8.png";